<div class="min-h-screen flex items-center justify-center relative bg-cover bg-center bg-no-repeat p-4" [style.background-image]="'url(' + backgroundImageUrl + ')'">
  <div class="absolute inset-0 bg-white/10 backdrop-blur-[2px]"></div>
  
  <div class="relative z-10 w-full max-w-[450px]">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="bg-white rounded-xl p-10 sm:p-8 sm:px-6 shadow-2xl flex flex-col gap-6 relative overflow-visible">
      <!-- Logo -->
      <div class="flex justify-center items-center mt-0 p-0 relative z-10 min-h-[60px] sm:min-h-[50px] max-h-[80px] sm:max-h-[70px] overflow-visible w-full">
        <app-image-tag 
          [src]="logoUrl" 
          [alt]="companyName + ' Logo'" 
          class=" h-8 w-8"
          [preventDownload]="true">
        </app-image-tag>
      </div>

      <!-- Username Type Toggle -->
      <!-- <div class="flex gap-2 mb-2 mt-0 border border-gray-200 rounded-lg p-1 bg-gray-50 relative z-10 toggle-container"> -->
        <!-- <app-button 
          type="button" 
          variant="secondary"
          size="sm"
          class="flex-1 min-w-0 toggle-btn"
          [class.active]="usernameType() === 'email'"
          (clicked)="switchUsernameType('email')">
          Email
        </app-button> -->
        <!-- <app-button 
          type="button" 
          variant="secondary"
          size="sm"
          class="flex-1 min-w-0 toggle-btn"
          [class.active]="usernameType() === 'mobile'"
          (clicked)="switchUsernameType('mobile')">
          Mobile
        </app-button> -->
      <!-- </div> -->

      <!-- Email Input -->
      <app-input
        *ngIf="usernameType() === 'email'"
        type="email"
        [label]="'login.email' | translate"
        [required]="true"
        [placeholder]="'login.enterEmail' | translate"
        formControlName="username"
        id="email"
        name="email">
      </app-input>

      <!-- Mobile Input with ISD Code -->
      <div class="flex flex-col gap-2" *ngIf="usernameType() === 'mobile'">
        <label for="mobile" class="text-sm font-medium text-gray-700">{{ 'login.mobile' | translate }}*</label>
        <div class="flex gap-2">
          <select 
            formControlName="isdCode"
            class="px-3 py-3 border border-gray-300 rounded-lg text-base bg-white cursor-pointer min-w-[80px] transition-all duration-200 focus:outline-none focus:border-primary-600 focus:ring-2 focus:ring-primary-100"
            (change)="onIsdCodeChange($event)">
            <option *ngFor="let isd of isdCodes" [value]="isd.code">
              {{ isd.code }}
            </option>
          </select>
          <input
            type="tel"
            id="mobile"
            formControlName="username"
            class="flex-1 w-full px-4 py-3 border border-gray-300 rounded-lg text-base transition-all duration-200 box-border focus:outline-none focus:border-primary-600 focus:ring-2 focus:ring-primary-100"
            [class.border-red-500]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched"
            [placeholder]="'login.enterMobile' | translate" />
        </div>
        <span class="text-xs text-red-500 -mt-1" *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
          {{ 'errors.validationError' | translate }}
        </span>
      </div>

      <!-- Password Input -->
      <app-input
        type="password"
        [label]="'login.password' | translate"
        [required]="true"
        [placeholder]="'login.enterPassword' | translate"
        formControlName="password"
        [showPasswordToggle]="true"
        id="password"
        name="password">
      </app-input>

      <!-- Login Button -->
      <app-button
        type="submit"
        variant="primary"
        [fullWidth]="true"
        [loading]="isLoading()"
        [disabled]="isLoading()">
        {{ isLoading() ? ('common.loading' | translate) : ('login.title' | translate) }}
      </app-button>

      <!-- Login with OTP Button -->
      <app-button
        type="button"
        variant="secondary"
        [fullWidth]="true"
        (clicked)="loginWithOTP()">
        {{ 'login.loginWithOTP' | translate }}
      </app-button>

      <!-- Google Login Button -->
      <!-- <app-button
        type="button"
        variant="google"
        [fullWidth]="true"
        (clicked)="loginWithGoogle()">
        <svg class="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        Login with Google
      </app-button> -->

      <!-- Forgot Password Link -->
      <a href="#" class="text-center text-primary-600 underline text-sm cursor-pointer transition-colors duration-200 hover:text-primary-700" (click)="forgotPassword(); $event.preventDefault()">
        {{ 'login.forgotPassword' | translate }}
      </a>

      <!-- Footer -->
      <div class="flex flex-col items-center gap-2 mt-4 pt-4 border-t border-gray-200">
        <app-image-tag 
          [src]="logoUrl" 
          [alt]="companyName + ' Logo'" 
          class="h-8 w-8 object-contain"
          [preventDownload]="true">
        </app-image-tag>
        <p class="text-xs text-gray-500 m-0">Powered by {{ poweredBy }}</p>
      </div>
    </form>
  </div>
</div>
